import { Node_Type } from "./../ricos-schema/next-schema/index.js";
const PmNodeType = {
  DIVIDER: Node_Type.DIVIDER,
  TOC: Node_Type.TOC,
  IMAGE: Node_Type.IMAGE,
  CAPTION: Node_Type.CAPTION,
  GALLERY: Node_Type.GALLERY,
  FILE: Node_Type.FILE,
  GIF: Node_Type.GIF,
  VIDEO: Node_Type.VIDEO,
  AUDIO: Node_Type.AUDIO,
  LINK_PREVIEW: Node_Type.LINK_PREVIEW,
  EMBED: Node_Type.EMBED,
  POLL: Node_Type.POLL,
  APP_EMBED: Node_Type.APP_EMBED,
  COLLAPSIBLE_LIST: Node_Type.COLLAPSIBLE_LIST,
  COLLAPSIBLE_ITEM: Node_Type.COLLAPSIBLE_ITEM,
  COLLAPSIBLE_ITEM_TITLE: Node_Type.COLLAPSIBLE_ITEM_TITLE,
  COLLAPSIBLE_ITEM_BODY: Node_Type.COLLAPSIBLE_ITEM_BODY,
  HTML: Node_Type.HTML,
  CODE_BLOCK: Node_Type.CODE_BLOCK,
  TABLE: Node_Type.TABLE,
  TABLE_ROW: Node_Type.TABLE_ROW,
  TABLE_CELL: Node_Type.TABLE_CELL,
  FIGURE: "FIGURE",
  LINK_BUTTON: "LINK_BUTTON",
  ACTION_BUTTON: "ACTION_BUTTON",
  TABLE_HEADER_CELL: "TABLE_HEADER_CELL",
  PARAGRAPH: Node_Type.PARAGRAPH,
  HEADING: Node_Type.HEADING,
  BULLETED_LIST: Node_Type.BULLETED_LIST,
  ORDERED_LIST: Node_Type.ORDERED_LIST,
  LIST_ITEM: Node_Type.LIST_ITEM,
  BLOCKQUOTE: Node_Type.BLOCKQUOTE,
  LAYOUT: Node_Type.LAYOUT,
  LAYOUT_CELL: Node_Type.LAYOUT_CELL,
  SMART_BLOCK: Node_Type.SMART_BLOCK,
  SMART_BLOCK_CELL: Node_Type.SMART_BLOCK_CELL,
  CARD: Node_Type.CARD,
  SHAPE: Node_Type.SHAPE,
  text: "text",
  hardbreak: "hardbreak"
};
export {
  PmNodeType
};
//# sourceMappingURL=pm-node-types.js.map
